// get_expertise_review
export const GET_EXPERTISE_REVIEW = 'get_expertise_review';
export const GET_EXPERTISE_REVIEW_SUCCESSFUL =
  'get_expertise_review_successfull';
export const GET_EXPERTISE_REVIEW_FAILED = 'get_expertise_review_failed';

// create_expertise_review
export const CREATE_EXPERTISE_REVIEW = 'create_expertise_review';
export const CREATE_EXPERTISE_REVIEW_SUCCESSFUL =
  'create_expertise_review_successfull';
export const CREATE_EXPERTISE_REVIEW_FAILED = 'create_expertise_review_failed';

// update_expertise_review
export const UPDATE_EXPERTISE_REVIEW = 'update_expertise_review';
export const UPDATE_EXPERTISE_REVIEW_SUCCESSFUL =
  'update_expertise_review_successfull';
export const UPDATE_EXPERTISE_REVIEW_FAILED = 'update_expertise_review_failed';

// delete_expertise_review
export const DELETE_EXPERTISE_REVIEW = 'delete_expertise_review';
export const DELETE_EXPERTISE_REVIEW_SUCCESSFUL =
  'delete_expertise_review_successfull';
export const DELETE_EXPERTISE_REVIEW_FAILED = 'delete_expertise_review_failed';
